export const convertURLs = (text) => {
  // Если текст пустой, возвращаем как есть
  if (!text || typeof text !== 'string') {
    return text;
  }
  
  // Пропускаем HTML (уже содержит ссылки)
  if (/<a\s+href=/i.test(text) || text.includes('</a>')) {
    return text;
  }
  
  // Обрабатываем экранированные символы
  let processed = text;
  processed = processed
    .replace(/\\"/g, '"')
    .replace(/\\'/g, "'")
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\r');
  
  // Убираем внешние кавычки если строка в них полностью
  const trimmed = processed.trim();
  if ((trimmed.startsWith('"') && trimmed.endsWith('"')) || 
      (trimmed.startsWith("'") && trimmed.endsWith("'"))) {
    processed = trimmed.slice(1, -1);
  }
  
  // Проверяем, есть ли URL в тексте
  const urlRegex = /https?:\/\/[^\s<>"'()]+/gi;
  const hasUrl = urlRegex.test(processed);
  
  if (!hasUrl) {
    return processed; // Возвращаем текст без изменений
  }
  
  // Восстанавливаем регулярное выражение для замены
  urlRegex.lastIndex = 0;
  
  // Заменяем URL на ссылки
  const withLinks = processed.replace(urlRegex,
    (url) => `<a href="${url}" class="external-link" target="_blank">${url}</a>`
  );
  
  const withLineBreaks = withLinks.replace(/\r\n|\r|\n/g, '<br />');
  // Оборачиваем в параграф
  return `<p>${withLineBreaks}</p>`;
}